const MediaCategoryType = Object.freeze({
  MAP: "MAP",
  PHOTO: "PHOTO",
  PLAN: "PLAN"
});
export default MediaCategoryType;